<div class="modal-header">
  <h4 class="modal-title" id="modal-title">{{influencerName()}}'s Referral list</h4>
  <button type="button" class="btn-close" aria-label="Close button" aria-describedby="modal-title"
          (click)="modal.dismiss('cancel')"></button>
</div>
<div class="modal-body">
  <app-sb-table
    [class.referrals-show-all]="showAll"
    [rows]="influencersList()"
    [totalRows]="totalRows()"
    [columns]="tableColumns"
    [options]="tableOptions"
    displayAllColumnsLabel="Display all columns"
    [displayAllColumns]="showAll"
    (displayAllColumnsChange)="showAllColumns($event)"
    (stateChange)="onTableState($event)">

    <ng-template sbTableCell="influencer_type" let-influencer>{{getInfluencerType(influencer.influencer_type_id)}}</ng-template>

    <ng-template sbTableCell="segment" let-influencer>{{getInfluencerSegment(influencer.project_influencer_segment_id)}}</ng-template>

    <ng-template sbTableCell="sessions" let-influencer>{{getSessionTitle(influencer)}}</ng-template>
  </app-sb-table>
</div>
<input type="hidden" ngbAutofocus>
<div class="modal-footer">
  <button type="button" class="btn btn-default" (click)="modal.close()">Close</button>
</div>
